<script setup lang="ts">
import {Play} from "utruckin-icons";

const props = defineProps<{
  documentUrl: string
}>()

const handleClick = (event: MouseEvent): void => {
  event.stopPropagation()
  window.open(props.documentUrl, "_blank");
}

</script>

<template>
  <div class="f-ui-video" @click="(e: MouseEvent) => {handleClick(e)}">
    <Play :size="16"></Play>
  </div>
</template>

<style scoped lang="scss">
.f-ui-video {
  width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--color-bg-secondary);
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -150%;
    height: 100%;
    width: 150%;
  }
}
</style>